import * as actionTypes from '../actions/allActionList';
import { FAILED_TO_SEND_LECTURE_COMMENT } from '../actions/allActionList';

const initialState = {
  fetchingLecturesStarted: false,
  fetchingLecturesDone: false,
  lectures: [],
  lectureCommentsInfo: [], // contains data returned
  individualLectureDetails: null,
  individualLectureComments: null,
  creatingLectureStarted: false,
  creatingLectureDone: false,

  /* Sending lecture comments helper properties */
  sendingStarted: false,
  sendingDone: false,
  failed: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.STARTED_FETCHING_LECTURES:
      return {
        ...state,
        fetchingLecturesStarted: true,
      };
    case actionTypes.INITIALIZE_LECTURES:
      return {
        ...state,
        lectures: action.lectures,
        fetchingLecturesStarted: false,
        fetchingLecturesDone: true,
      };
    case actionTypes.STARTED_CREATING_LECTURE:
      return {
        ...state,
        creatingLectureStarted: true,
        creatingLectureDone: false,
      };
    case actionTypes.FAILED_CREATING_LECTURE:
      return {
        ...state,
        creatingLectureStarted: false,
        creatingLectureDone: true,
      };
    case actionTypes.FINISHED_CREATING_LECTURE:
      return {
        ...state,
        lectures: action.lectures,
        creatingLectureStarted: false,
        creatingLectureDone: true,
      };
    case actionTypes.RESET_CREATING_LECTURE_DATA:
      return {
        ...state,
        creatingLectureStarted: false,
        creatingLectureDone: false,
      };
    case actionTypes.SET_INIDIVIDUAL_LECTURE_DATA:
      return {
        ...state,
        individualLectureDetails: action.lecture,
      };
    case actionTypes.RESET_INIDIVIDUAL_LECTURE_DATA:
      return {
        ...state,
        individualLectureDetails: null,
        individualLectureComments: null,
      };
    case actionTypes.GOTTEN_LECTURE_COMMENTS:
      return {
        ...state,
        lectureCommentsInfo: action.commentsInfo,
        individualLectureComments: action.comments,
      };
    case actionTypes.FAILED_TO_GET_LECTURE_COMMENTS:
      return {
        ...state,
        individualLectureComments: action.comments,
      };
    case actionTypes.STARTED_SENDING_LECTURE_COMMENT:
      return {
        ...state,
        sendingStarted: true,
        sendingDone: false,
        failed: false,
      };
    case actionTypes.SENT_LECTURE_COMMENT:
      return {
        ...state,
        individualLectureComments: action.comments,
        lectureCommentsInfo: action.commentsInfo,
        sendingStarted: false,
        sendingDone: true,
        failed: false,
      };
    case FAILED_TO_SEND_LECTURE_COMMENT:
      return {
        ...state,
        sendingStarted: false,
        sendingDone: true,
        failed: true,
      };
    default:
      return state;
  }
};

export default reducer;
